// Feste Kataloge fuer Produkttyp- und Lieferstatus-Mapping.
// Gambio hat KEINE REST-Katalog-API fuer shipping_status/product_type (v2 UND v3 -> ConnectError),
// daher hier fest hinterlegt. Wird auch vom Listing-Slot (Folge-Etappe) genutzt.

export const GAMBIO_PRODUCT_TYPES = [
  { value: '1', label: 'Standard' },
  { value: '2', label: 'Download' },
  { value: '3', label: 'Dienstleistung' },
] as const;

export const GAMBIO_SHIPPING_STATUS = [
  { value: '1', label: 'ca. 3-4 Tage' },
  { value: '2', label: 'ca. 1 Woche' },
  { value: '3', label: 'ca. 2 Wochen' },
] as const;

// Vario-Seite (links): feste Enums.
export const VARIO_PRODUCT_TYPES = [
  { value: 'WITH_STOCK', label: 'Lagerartikel' },
  { value: 'WITHOUT_STOCK', label: 'Artikel ohne Lager' },
  { value: 'SERVICE_ARTICLE', label: 'Dienstleistung' },
  { value: 'VARIANT_MAIN_ARTICLE', label: 'Variantenartikel' },
] as const;

export const VARIO_STOCK_STATES = [
  { value: 'in_stock', label: 'Auf Lager (Bestand > 0)' },
  { value: 'out_of_stock', label: 'Nicht auf Lager (Bestand = 0)' },
] as const;
